module.exports = __webpack_public_path__ + "img/0Q3A3494_L_Black.2f2c30f3.jpg";